const services = [
  {
    label: "Health Insurance",
    icon: "⚕️",
    description:
      "Comprehensive medical cover to ensure you get the best treatment without financial stress.",
    featured: true,
  },
  {
    label: "Life Insurance",
    icon: "🛡️",
    description:
      "Protecting your family’s lifestyle and future even when you're not around.",
  },
  {
    label: "Wealth Plans",
    icon: "💼",
    description:
      "Tailored investment strategies to grow your savings and secure your financial legacy.",
  },
  {
    label: "Retirement Plans",
    icon: "🌅",
    description:
      "Ensuring your golden years are lived with dignity and financial independence.",
  },
  {
    label: "Education Plans",
    icon: "🎓",
    description:
      "Guaranteeing your children's dreams are realized through stable educational funding.",
  },
  {
    label: "Income Protection",
    icon: "📈",
    description:
      "A safety net that replaces your income if you are unable to work due to illness.",
  },
];

export default function Services() {
  return (
    <section id="services" className="bg-slate-50 py-24">
      <div className="mx-auto max-w-7xl px-6">
        {/* Header */}
        <div className="mb-16">
          <span className="text-red-600 font-bold tracking-widest uppercase text-sm">
            Solutions
          </span>
          <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Protection Built for Your Life
          </h2>
          <p className="mt-4 text-slate-600 max-w-2xl text-lg leading-relaxed">
            I don’t believe in one-size-fits-all. I combine AIA’s global
            strength with my personal experience to craft plans that actually
            work when you need them most.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s) => (
            <div
              key={s.label}
              className={`relative group rounded-3xl p-8 transition-all duration-300 hover:-translate-y-2 ${
                s.featured
                  ? "bg-red-600 text-white shadow-xl shadow-red-200 ring-1 ring-red-700"
                  : "bg-white text-slate-900 shadow-md hover:shadow-xl ring-1 ring-slate-200"
              }`}
            >
              {/* Icon */}
              <div
                className={`mb-6 flex h-14 w-14 items-center justify-center rounded-2xl text-3xl shadow-inner ${
                  s.featured ? "bg-white/20" : "bg-red-50"
                }`}
              >
                {s.icon}
              </div>

              {/* Content */}
              <h3
                className={`text-xl font-bold ${
                  s.featured ? "text-white" : "text-slate-900"
                }`}
              >
                {s.label}
              </h3>
              <p
                className={`mt-3 text-sm leading-relaxed ${
                  s.featured ? "text-red-50" : "text-slate-600"
                }`}
              >
                {s.description}
              </p>

              {/* Subtle Arrow Decor */}
              <div
                className={`mt-6 flex items-center gap-2 text-sm font-bold uppercase tracking-wider transition-opacity group-hover:opacity-100 opacity-0 ${
                  s.featured ? "text-white" : "text-red-600"
                }`}
              >
                Learn More
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-16 text-center">
          <p className="text-slate-500 text-sm font-medium">
            * All plans are customizable based on your age, income, and family
            needs.
          </p>
        </div>
      </div>
    </section>
  );
}
